import { isString } from 'lodash';
import { validatePolish } from 'validate-polish';

import { Bean, FieldControllerProps, Validate } from '@dreryk/react-common';
import { ClassNameProp, TextInput } from '@dreryk/react-components';

import { healthcareProviderTranslationKeys } from '../../translations';

type TaxIdentifierInputProps = FieldControllerProps<'taxIdentifier', string | null> & ClassNameProp;
const validateNIP: Validate<Bean> = (data) => {
   if (isString(data) && !validatePolish.nip(data)) {
      return healthcareProviderTranslationKeys.invalidNip;
   }

   return undefined;
};

export const TaxIdentifierInput = (props: TaxIdentifierInputProps): JSX.Element => {
   const controller = props.register(props.name, {
      required: props.required,
      maxLength: 10,
      validate: validateNIP,
   });

   return (
      <TextInput
         testId={props.name}
         label={healthcareProviderTranslationKeys.taxIdentifier}
         controller={controller}
         defaultValue={props.defaultValue}
         className={props.className}
      />
   );
};
